// DishEditDrawer.jsx
import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XCircleIcon } from '@heroicons/react/20/solid';
import MenuDish from '../../MenuDish/MenuDish';

export const DishEditDrawer = ({ isOpen, onClose, dishItem }) => {
  if (!dishItem) return null;

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed inset-0 overflow-hidden"
        open={isOpen}
        onClose={onClose}
      >
        <div className="absolute inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={onClose}
          >
            <div
              className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
              onClick={onClose}
            />
          </Transition.Child>

          <div className="fixed inset-y-0 bottom-0 pt-10 max-w-full max-h-full flex">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-y-full"
              enterTo="translate-y-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-y-0"
              leaveTo="translate-y-full"
            >
              <div className="w-screen max-w-md">
                <div className="h-full flex flex-col py-6 bg-surface shadow-xl overflow-y-auto rounded-md">
                  <div className="px-4 sm:px-6">
                    <div className="flex items-start justify-end">
                      <div className="ml-3 h-4 flex items-center">
                        <button
                          className="bg-surface rounded-md text-primary hover:text-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                          onClick={onClose}
                        >
                          <span className="sr-only">Close panel</span>
                          <XCircleIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 relative flex-1">
                    <MenuDish
                      editableVersion={true}
                      menuItemId={dishItem.menu_item_id}
                      i_ts={dishItem.cart_insert_ts}
                      callback={onClose}
                    />
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
